import * as React from 'react';
import { WETNOTES_TITLE } from '../../constants/wetnotes';

enum COLOR_TYPE {
  white = 'white',
  black = 'black',
  red = 'red'
}

interface IProps {
  title?: string;
  color?: keyof typeof COLOR_TYPE;
}

const WetnotesLogo = ({ title = WETNOTES_TITLE, color = COLOR_TYPE.white }: IProps) => {
  return (
    <span className={`wetnotes--logo ${color}__color`}>
      {title}
    </span>
  );
};

export default WetnotesLogo;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/WetnotesLogo/WetnotesLogo.tsx